module.exports = __webpack_public_path__ + "I5U0-n.png?faa264c9ce9126c0a9139e504bfd3428";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/I5U0-n.png
// module id = 96
// module chunks = 0